function initTabbedMediaCarouselFilter() {
    document.addEventListener('click', (event) => {
        const link = event.target.closest('.gallery-filter-link');
        if (!link) return;

        const block = link.closest('.swiperGalleryBlock');
        if (!block) return;

        event.preventDefault();

        const slidesWrapper = block.querySelector('[data-gallery-slides]');
        if (!slidesWrapper) return;

        const slider = block.querySelector('.swiperGallerySlider');
        const swiper = slider?.swiper;
        if (!swiper) return;

        const links = block.querySelectorAll('.gallery-filter-link');
        links.forEach((item) => {
            item.classList.toggle('active', item === link);
            item.setAttribute('aria-pressed', item === link ? 'true' : 'false');
        });

        const activeTerm = link.dataset.term || 'all';
        const slides = slidesWrapper.querySelectorAll('.swiper-slide');

        slides.forEach((slide) => {
            const isVisible = activeTerm === 'all' || slide.dataset.term === activeTerm;
            slide.hidden = !isVisible;
            slide.style.display = isVisible ? '' : 'none';
            slide.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
        });

        swiper.update();
        swiper.slideTo(0, 0);
    });
}

window.addEventListener('load', initTabbedMediaCarouselFilter);
